import { apiClient } from './client';

export type AutoMessageTrigger =
  | 'on_signup'
  | 'on_first_chat'
  | 'inactive_24h'
  | 'after_deposit'
  | 'on_new_client'
  | 'on_first_deposit'
  | 'idle'
  | 'manual';

export interface AutoMessage {
  id: string;
  tenantId: string;
  trigger: AutoMessageTrigger;
  delaySeconds: number;
  template: string;
  isActive: boolean;
  createdAt: string;
}

export interface CreateAutoMessageBody {
  trigger: AutoMessageTrigger;
  delaySeconds: number;
  template: string;
  isActive?: boolean;
}

export interface UpdateAutoMessageBody {
  trigger?: AutoMessageTrigger;
  delaySeconds?: number;
  template?: string;
  isActive?: boolean;
}

export const autoMessagesApi = {
  list: async (): Promise<AutoMessage[]> => {
    const { data } = await apiClient.get('/admin/auto-messages');
    return data as AutoMessage[];
  },

  get: async (id: string): Promise<AutoMessage> => {
    const { data } = await apiClient.get(`/admin/auto-messages/${id}`);
    return data as AutoMessage;
  },

  create: async (body: CreateAutoMessageBody): Promise<AutoMessage> => {
    const { data } = await apiClient.post('/admin/auto-messages', body);
    return data as AutoMessage;
  },

  update: async (id: string, body: UpdateAutoMessageBody): Promise<AutoMessage> => {
    const { data } = await apiClient.patch(`/admin/auto-messages/${id}`, body);
    return data as AutoMessage;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/auto-messages/${id}`);
  },
};
